import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import { Popover } from 'antd';
import { css, cx } from 'emotion';
import { colorLabelBlue, getAnchorStyle, getPopoverInfoStyle } from 'styles/base.js';


const iconStyle = css`
    width: auto;
    margin-right: 5px;
    display: flex;
    align-items: center;
    .fa {
        color: ${colorLabelBlue};
        font-size: 10px;
    }
`;


export default class InfoIcon extends React.Component {
    static propTypes = {
        // Can be test , JSX, or another component
        message: PropTypes.any.isRequired,

        // Options: top, topLeft, topRight, leftTop, left, leftBottom, rightTop, right, rightBottom, bottomLeft, bottom, bottomRight
        tooltipPosition: PropTypes.string,

        // If you want a title to your info box
        title: PropTypes.string,

        className: PropTypes.string,

        // default is i icon
        icon: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };
    }

    onVisibleChange = () => {
        this.setState({
            visible: !this.state.visible
        });
    };

    render() {
        const tooltipPosition = this.props.tooltipPosition ? this.props.tooltipPosition : 'topLeft';
        const anchorStyle = css`
            margin-top: 10px;
            align-self: flex-end;
            ${getAnchorStyle(colorLabelBlue)}
        `;

        let message = this.props.message;
        if (typeof this.props.message === 'function') {
            message = React.createElement(this.props.message, {});
        }

        const content = (
            <Flexbox flexDirection="column">
                {message}
                <a className={anchorStyle} onClick={this.onVisibleChange}>Close</a>
            </Flexbox>
        );

        const popoverStyle = getPopoverInfoStyle('100%');
        const icon = this.props.icon ? this.props.icon : 'fa-info-circle';

        return (
            <Popover content={content}
                placement={tooltipPosition}
                title={this.props.title}
                overlayClassName={popoverStyle}
                trigger="click"
                visible={this.state.visible}
            >
                <a className={cx(iconStyle, this.props.className)} onClick={this.onVisibleChange} >
                    <i className={`fa ${icon}`}/>
                </a>
            </Popover>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/InfoIcon.js